<template>
  <v-list v-if="menu.length">
    <template v-for="(item, i) in menu">
      <v-list-tile
        class="links mb-1"
        :key="i"
        :to="{name: item.route, params: item.params}"
      >
        <v-list-tile-action>
          <v-icon color="orange">{{ $vuetify.icons[item.icon] }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
</template>

<script>
export default {
  props: ["menu"]
};
</script>
